<template>
  <div>
    <v-carousel
      cycle
      height="200"
      hide-delimiter-background
      show-arrows-on-hover
    >
      <v-carousel-item v-for="(item, i) in items" :key="i" :src="item.src">
        <v-row class="fill-height" align="center" justify="center">
          <v-col class="d-flex flex-column justify-center align-center">
            <div class="text-h3 text-center">{{ item.title }}</div>
          </v-col>
        </v-row>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          title: "Free Shipping",
          src: require("../assets/bike.jpg"),
        },
        {
          title: "Refer friends",
          src: require("../assets/friends.png"),
        },
        {
          title: "All Auctions will close",
          src: require("../assets/yes.jpg"),
        },
        {
          title: "Brand new items",
          src: require("../assets/New.jpg"),
        },
      ],
    };
  },
};
</script>
